import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import { api, SESSION_MARKER_KEY } from "@/api";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "home", component: HomeView },
    {
      path: "/score/:sport(football|basketball)?",
      name: "scores",
      component: () => import("@/views/MatchesView.vue"),
    },
    { path: "/matches", redirect: "/score/football" },
    {
      path: "/lives",
      name: "lives",
      component: () => import("@/views/LiveView.vue"),
    },
    { path: "/live", redirect: "/lives" },
    {
      path: "/live/:id",
      name: "live-room",
      component: () => import("@/views/LiveRoomView.vue"),
    },
    {
      path: "/schedules",
      name: "schedules",
      component: () => import("@/views/SchedulesView.vue"),
    },
    {
      path: "/data",
      name: "data",
      component: () => import("@/views/DataView.vue"),
    },
    {
      path: "/video",
      name: "video",
      component: () => import("@/views/VideoView.vue"),
    },
    {
      path: "/news",
      name: "news",
      component: () => import("@/views/ContentView.vue"),
    },
    {
      path: "/download",
      name: "download",
      component: () => import("@/views/DownloadView.vue"),
    },
    {
      path: "/terms",
      name: "terms",
      component: () => import("@/views/LegalDocumentView.vue"),
      props: { kind: "terms" },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("@/views/LegalDocumentView.vue"),
      props: { kind: "privacy" },
    },
    { path: "/protocol", redirect: "/terms" },
    { path: "/content", redirect: "/news" },
    {
      path: "/article/:id",
      name: "article",
      component: () => import("@/views/ArticleDetailView.vue"),
    },
    {
      path: "/match/:id",
      name: "match-detail",
      component: () => import("@/views/MatchDetailView.vue"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/views/SearchView.vue"),
    },
    {
      path: "/messages",
      name: "messages",
      component: () => import("@/views/MessagesView.vue"),
      meta: { auth: true },
    },
    {
      path: "/wallet",
      name: "wallet",
      component: () => import("@/views/WalletView.vue"),
      meta: { auth: true, funds: true },
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/views/ProfileView.vue"),
      meta: { auth: true },
    },
    {
      path: "/login",
      name: "login",
      redirect: (to) => ({
        name: "home",
        query: {
          auth: "login",
          ...(typeof to.query.redirect === "string"
            ? { redirect: to.query.redirect }
            : {}),
        },
      }),
    },
    {
      path: "/register",
      name: "register",
      redirect: {
        name: "home",
        query: { auth: "register" },
      },
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
  if (to.meta.auth && !localStorage.getItem(SESSION_MARKER_KEY)) {
    return {
      name: "home",
      query: { auth: "login", redirect: to.fullPath },
    };
  }
  if (to.meta.funds) {
    try {
      const response = await api.payment.getPaymentAvailability({});
      if (response.availability?.enabled !== true) {
        return { name: "profile" };
      }
    } catch {
      return { name: "profile" };
    }
  }
  return true;
});
